import React from "react";

const FormTextarea = ({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  required = false,
  rows = 5,
  className = "",
  register,
  error,
  ...rest
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-[#636363] mb-1">
          {label}{required && <span className="text-red-500">*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        rows={rows}
        placeholder={placeholder}
        required={required}
        className="w-full rounded-md border border-[#CACACA] px-4 py-2 text-sm text-[#1100EF] placeholder:text-[#858585] focus:text-[#000] bg-[#F6F6F6] focus:outline-none focus:ring-2 focus:ring-blue-500"
        {...(register && name ? register(name) : { value, onChange })}
        {...rest}
      />
    </div>
  );
};

export default FormTextarea;
